<template>
  <div class="cmp-royalty-list dt-page">
    <div v-if="!loading && royalties && royalties.length > 0" class="royalty-list">
      <NTable :id="'b2b-royalty-royalty_list'" :headers="headers" :items="royalties" class="royalty-list h1"
        :config="royaltyTableConfig" thpad="0px" tdpad="0px" thspad="0px 10px 0px 10px">
        <template v-slot:item="{ item, tdcon }">
          <tr :class="{
            selected: selectedRow(item),
          }" @click="onRowClicked(item)">
            <td v-bind="tdcon('detailsb2b_account')">
              <span :title="item.royalty_account_name" > {{ item["royalty_account_name"] }}</span>
            </td>
            <td v-bind="tdcon('detailsb2b_period')">
              <span>{{ item["period"] }}</span>
            </td>
            <td v-bind="tdcon('net_amount')">
              <span v-if="item.net_amount && item.net_amount != '0.00'" style="text-align: right">{{ item["net_amount"] }}
                <span  style="font-weight: 500">{{
                  item["currency_iso"]
                }}</span></span>
            </td>
            <td v-bind="tdcon('vat')">
              <span v-if="item.vat && item.vat != '0.00'" style="text-align: right">{{ item["vat"] }}
                <span  style="font-weight: 500">{{
                  item["currency_iso"]
                }}</span></span>
            </td>
            <td v-bind="tdcon('tax_deduction_text')">
              <span v-if="item.tax_deductions && item.tax_deductions != '0.00'" style="text-align: right">{{ item["tax_deductions"] }}
                <span  style="font-weight: 500">{{
                  item["currency_iso"]
                }}</span></span>
            </td>
            <td v-bind="tdcon('payment_amount')">
              <span v-if="item.payment_amount && item.payment_amount != '0.00'" style="text-align: right">{{ item["payment_amount"] }}
                <span  style="font-weight: 500">{{
                  item["currency_iso"]
                }}</span></span>
            </td>
            <td v-bind="tdcon('amount_carried_forward')">
              <span v-if="item.amount_carried_forward && item.amount_carried_forward != '0.00'" style="text-align: right">{{ item["amount_carried_forward"] }}
                <span 
                  style="font-weight: 500">{{
                    item["currency_iso"]
                  }}</span></span>
            </td>
            <td v-bind="tdcon('credit_note')">
              <span style="font-weight: 500">
                <div v-if="item.has_credit_note != ''">
                  <a target="_blank" style="color:black" :href="item['invoice_external_link']"> {{ item["has_credit_note"]
                  }}</a>
                </div>


              </span>
            </td>
            
            <td v-bind="tdcon('stmt_link')">
              <div>
                <a target="_blank" rel="noopener noreferrer" :href="item['stmt_link']"><img width="20" height="20"
                    src="static/icons/b2b/statement_transparent.png" /></a>
              </div>
            </td>
            <td v-bind="tdcon('excel_link')">
              <div>
                <!-- <img
                      @click.stop="(e) => onPDFClick(item)"
                      src="static/icons/pdf.svg"
                      class="dt-icon v5 s2"
                      alt
                      :title="`${$t('pdf')}`"
                    /> -->
                <a :href="item['excel_link']"><img width="20" height="20" src="static/icons/b2b/ms-excel.png" /></a>
              </div>
            </td>

<td v-bind="tdcon('pdf_click')" >
              <div class="dt-icon-container">
                    <img
                      @click.stop="(e) => onPDFClick(item)"
                      src="static/icons/pdf.svg"
                      class="dt-icon v5 s2"
                      alt
                      :title="`${$t('pdf')}`"
                    />
                  </div>
            </td>
            <!-- <td v-bind="tdcon('more_icon')">
              <span><img src="static/icons/b2b/more_icon.svg" /></span>
            </td> -->
          </tr>
        </template>
      </NTable>
    </div>
    <div v-if="loading">
      <v-progress-linear indeterminate color="indigo darken-2" striped light :height="height"></v-progress-linear>
    </div>
    <B2BWelcomeComponent :message="message" v-if="!loading && royalties && royalties.length === 0"></B2BWelcomeComponent>
  </div>
</template>

 


<script>
import { B2BStoreNamespace as storeNS } from "../../store/index";
import InputField from "@plugins/text-field/input-field";
import Dropdown from "@plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import * as types from "../../store/types";
import B2BWelcomeComponent from "../welcome";
import { isMobile, downloadPDF,downloadB2BPDF } from "../../../../utility";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { clientName } from "../../../../modules/b2b/services/http-client.js";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    B2BWelcomeComponent,
    InputField,
    NTable,
  },
  data() {
    return {
      selected: [],
      isDesc: true,
      height: "4",
      message: "",
      royaltyTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
      }),
    };
  },
  watch: {
    activeRouteItem: function () {
      this.message = this.getMessage();
    },
    activeSubRouteItem: function () {
      this.message = this.getMessage();
    },
    royalties: function () {
      this.message = this.getMessage();
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      user: "user",
      royaltyList: "royalties",
      activeRouteItem: "activeRouteItem",
      activeSubRouteItem: "activeSubRouteItem",
      royaltyReports: "royaltyReports",
      has_credit_note: "has_credit_note",
    }),
    headers: function () {
      return [
        createTableHeader("detailsb2b_account"),
        createTableHeader("detailsb2b_period", {
          f:0.5,
          ta: "left",
        }),
        createTableHeader("net_amount", {
          ta: "right",
          f:0.6,
        }),
        createTableHeader("vat", {
          ta: "right",
          ff:0.5,
        }),
        createTableHeader("tax_deduction_text", {
          ta: "right",
          f:0.8,
        }),
        createTableHeader("payment_amount", {
          ta: "right",
          f:0.8,
        }),
        createTableHeader("amount_carried_forward", {
          ta: "right",
          f:1.2,
        }),
        createTableHeader("credit_note", {
          f:0.7,
        }),
       
        createTableHeader("stmt_link", {
          text: this.$t('detailsb2b_statement_overview'),
          f:0.9,
          ta: "right",
        }),
        createTableHeader("excel_link", {
          text: this.$t('detailsb2b_statement_download'),
          f:0.9,
          ta: "right",
        }),
         createTableHeader("pdf_click", {
          text: false,
          f:0.5,
          ta: "right",
        }),

      ]

    },
    royalties: function () {
      return this.royaltyList
        ? this.royaltyList.map((e) => {
          e.total_gross_amount =
            e.payment_amount === 0.00 ||
              e.payment_amount === "0.00"
              ? e.amount_carried_forward
              : e.payment_amount;
          return e;
        })
        : [];
    },
    ...mapState(storeNS, {
      loading: "is_Loaded_Data",
      loading_Text: "loading_Text",
    }),
  },
  methods: {
    ...mapActions(storeNS, {
      [types.B2B_FETCH_ROYALTY_TOP_15_REPORT]:
        types.B2B_FETCH_ROYALTY_TOP_15_REPORT,
    }),
    changSort(header) {
      this.isDesc = !this.isDesc;
    },
    customSort(items, index) {
      items.sort((a, b) => {
        if (!this.isDesc) {
          return a[index] < b[index] ? -1 : 1;
        } else {
          return b[index] < a[index] ? -1 : 1;
        }
      });
      return items;
    },
    onPDFClick: async function (item) {
      console.log('user',this.user)
      const { royalty_account_name } = item;
      const filename = `${royalty_account_name}.pdf`;
      const account = {
        client: {
          clientID: clientName
        },
        ...this.user
      }

      downloadPDF(item.stmt_link, account, filename);
    },
    openTab(item) {
      this.$store.commit(
        `${storeNS}/${types.B2B_SET_SELECTED_ROYALTY_ITEM}`,
        item
      );
      const routeData1 = this.$router.resolve({
        name: "Royalty_Top_Reports",
        params: { royalty_period_id: item.royalty_period_id },
      });
      window.open(routeData1.href, "_blank");
    },
    onSearchInputKeyup() { },
    selectedRow() { },
    onRowClicked() { },
    getMessage: function () {
      let message = "";
      if (
        this.activeRouteItem &&
        this.activeRouteItem.children &&
        this.activeRouteItem.children.length === 0
      ) {
        message = "Currently there’s no royalty statements available.";
      } else if (
        this.activeSubRouteItem &&
        this.royalties &&
        this.royalties.length === 0
      ) {
        message = `Currently there’s no royalty statement available for ${this.activeSubRouteItem.route}.`;
      } else {
        message = "";
      }
      return message;
    },
  },
};
</script>

<style lang="scss"  >
.cmp-royalty-list {
  height: 100%;
  overflow: hidden;

  .dt-ntable.royalty-list {
    height: 100%;
    overflow: hidden;
    --ntable-height: none;

    td.stmt_link,
    td.excel_link,
    td.more_icon {
      cursor: pointer;
    }

    // th:nth-child(7),
    // td:nth-child(7) {
    //   display: none;
    // }
    @media (min-width: 320px) and (max-width: 800px) {
      --ntable-height: 250px !important;

      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(6),
      td:nth-child(6),
      th:nth-child(7),
      td:nth-child(7),
      th:nth-child(8),
      td:nth-child(8),
      th:nth-child(9),
      td:nth-child(9),
      th:nth-child(10),
      td:nth-child(10) {
        display: none;
      }

    }

    th {
      color: #282828;
      font-weight: 700;
      font-family: Roboto;
      font-size: 13px;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: 1px solid #c8c8c8;

      a {
        color: #0087ff;
        font-family: Roboto;
        font-size: 13px;
        line-height: 18px;
      }
    }

    td.btn_account {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    td {
      cursor: auto;
    }

    thead {
      tr {
        border-bottom: 1px solid #282828 !important;
      }

      th {
        color: #13110f !important;
      }

      &.style1 {
        --ntable-header-color: #13110f !important;
        --ntable-bb-color: #13110f !important;
      }

      &.style2 {
        --ntable-bb-color: #13110f !important;
      }
    }
  }
}
</style>

